import React, { FC, useEffect, useState } from "react";
import {
  ApproveState,
  useApprovalForAll,
} from "../../../../../hooks/erc721/useApprovalForAll";
import { NFTExport, NFTType } from "../../../../../models/exports";
import Button from "../../../../common/button/button";
import Card from "../../../../common/card/card";
import Loading from "../../../../loading/loading";

interface NftApproveStatusProps {
  contract: NFTType;
  operatorAddr: string;
  selectedNfts: NFTExport[];
  isApprovedCallback: Function;
}

const NftApproveStatus: FC<NftApproveStatusProps> = ({
  contract,
  operatorAddr,
  selectedNfts,
  isApprovedCallback,
}) => {
  const { isApproved, setApprovalForAll } = useApprovalForAll(
    contract.contract,
    operatorAddr
  );

  const [msg, setMsg] = useState("");

  //Once approved let parent know
  useEffect(() => {
    if (isApproved === ApproveState.APPROVED) {
      isApprovedCallback(contract.contract);
    }
  }, [isApproved]);

  useEffect(() => {
    switch (isApproved) {
      case ApproveState.UNAPPROVED:
        setMsg(`approve ${contract.name}`);
        break;
      case ApproveState.PENDING:
        setMsg(`approving ${contract.name}`);
        break;
      case ApproveState.APPROVED:
        setMsg(`approved ${contract.name.toLowerCase()}`);
        break;
      default:
        setMsg("unapproved");
    }
  }, [isApproved]);
  return (
    <Card
      title={contract.name}
      subtitle={`${selectedNfts.length} NFT${
        selectedNfts.length > 1 ? "s" : ""
      }`}
      style={{ width: "326px" }}
    >
      <div className="flex flex-col space-y-24">
        <div className="flex flex-col space-y-8">
          <p className="caption text-dark-white-64">Status</p>
          <p className="body2 text-white">
            {isApproved !== ApproveState.APPROVED
              ? "Needs approval"
              : "Approved"}
          </p>
        </div>
        {(isApproved === ApproveState.UNAPPROVED ||
          isApproved === ApproveState.PENDING) && (
          <Button
            onClick={setApprovalForAll}
            disabled={isApproved === ApproveState.PENDING}
            width="full"
          >
            {isApproved === ApproveState.PENDING ? (
              <Loading size={24} color="#000000" />
            ) : (
              "Approve"
            )}
          </Button>
        )}
      </div>
    </Card>
  );
};

export default NftApproveStatus;
